module.exports = __webpack_public_path__ + "img/member1.a56bc43.jpg";